import styled from '@emotion/styled';

export const CardMedia = styled.div<{ size: 'small' }>`
    height: ${({ theme, size }) => theme.card.media.height[size]}px;
    background-color: ${({ theme }) => theme.colors.black};
    background-image: url('https://picsum.photos/800/256');
    background-size: cover;
`;
